import { HTTP } from "@/plugins/axios";
import ProductType from "@/enums/ProductType";

const categories = {
    namespaced: true,
    state: {
        categories: {},
    },
    mutations: {
        SET_CATEGORIES(state, value) { state.categories = value },
    },
    actions: {
        GET_ALL_CATEGORIES({ commit }) {
            return new Promise((resolve, reject) => {
                HTTP.get(`/ClientSide/Get?start=0&end=10&objectName=${ProductType.ProductType}`)
                    .then((response) => {
                        commit('SET_CATEGORIES', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        commit('SET_CATEGORIES', {})
                        reject(error)
                    });
            })
        },
    },
    getters: {
        categories: state => state.categories,
    }
}

export default categories;